<template>
    <div>

        <div>
            <div style="font-size: 20px; margin-top: 40px; margin-left: 40px; font-weight: 600;">岗位管理</div>
            <el-row style="margin-top: 9px;">
                <div style="height: 750px; background-color: #FFFFFF; margin: 0px 40px;">

                    <el-row style="padding-left: 46px; padding-top: 40px;">

                        <el-col :span="4">
                            <span>岗位名称</span>
                            <el-input v-model="condition.post_name" placeholder="请输入岗位名称"
                                style="width: 65%; margin-left: 10px;">
                            </el-input>
                        </el-col>

                        <el-col :span="8">
                            <el-button
                                style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
                                @click="Find">
                                查询</el-button>
                            <el-button
                                style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
                                @click="Del(null)">
                                删除</el-button>
                            <el-button style="width: 85px; border: 1px solid #006E4B; color: #006E4B;" @click="AddFrom">
                                新增</el-button>
                        </el-col>

                    </el-row>

                    <el-row style="margin: 0px 2%; margin-top: 10px;">
                        <el-row>
                            <el-table :header-cell-style="{background:'#F0F0F0',color:'#000000'}"
                                :row-class-name="tableRowClassName" ref="multipleTable" :data="tableData" height="540"
                                tooltip-effect="dark" style="width: 100%;" @selection-change="handleSelectionChange">
                                <el-table-column type="selection" width="55">
                                </el-table-column>
                                <el-table-column align="center" label="序号">
                                    <template slot-scope="scope_1">{{scope_1.$index + 1}}</template>
                                </el-table-column>
                                <el-table-column prop="post_name" align="center" label="岗位"></el-table-column>
                                <el-table-column prop="create_time" align="center" label="生成时间"></el-table-column>
                                <el-table-column align="center" label="操作">
                                    <template slot-scope="scope">
                                        <img src="../../../assets/编辑.png" @click="UpdateFrom(scope.row)">
                                        <img src="../../../assets/删除.png" @click="Del(scope.row.id)"
                                            style="margin-left: 10px" />
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-row>
                        <el-row style="margin-top: 10px; text-align: center;">
                            <el-pagination background @current-change="handleCurrentChange" :page-size="page_size"
                                layout=" prev, pager, next, jumper" :total="total">
                            </el-pagination>
                        </el-row>
                    </el-row>
                </div>
            </el-row>
        </div>

        <div>
            <el-dialog :title="from.id == null || from.id == '' ? '添加岗位' : '修改岗位'" :visible.sync="dialogVisible"
                width="30%" :close-on-click-modal="false" :center="true">

                <el-form :model="from" :rules="rules" ref="from" style="padding: 0 10%;" label-width="100px">
                    <el-form-item label="岗位" prop="post_name">
                        <el-input v-model="from.post_name" placeholder="请输入角色名称" style="width: 100%;"></el-input>
                    </el-form-item>
                    <el-form-item style="text-align: center;" label-width="0px">
                        <el-button type="primary" @click="Add" v-show="from.id == null || from.id == ''"
                            style="width: 30%; background-color: #006E4B; border: 1px solid #006E4B;">保存</el-button>
                        <el-button type="primary" @click="Update" v-show="from.id != null && from.id != ''"
                            style="width: 30%; background-color: #006E4B; border: 1px solid #006E4B;">修改</el-button>
                    </el-form-item>
                </el-form>

            </el-dialog>
        </div>

    </div>
</template>

<script>
    import axios from "axios";
    export default {
        data() {
            return {
                //列表相关
                page_num: 1,
                page_size: 10,
                total: 0,
                tableData: [],

                //页面相关
                dialogVisible: false,
                eidtRedirection: false,

                //条件
                condition: {
                    project_id: [],
                    post_name: "",
                },

                //详情
                from: {
                    id: "",
                    post_name: "",
                },

                //复选框ids
                ids: [],

                //表单验证
                rules: {
                    post_name: [{
                        required: true,
                        message: '请输入岗位名称！',
                        trigger: 'blur'
                    }],
                }
            };
        },
        methods: {
            //返回
            Return(e) {
                this.dialogVisible = false;
                this.Find();
            },
            //列表点击复选框
            handleSelectionChange(e) {
                this.ids = [];
                e.forEach(item => {
                    this.ids.push(item.id);
                })
            },
            //查询
            Find() {
                const url = this.$globals.http + "post/find";
                axios.post(url, {
                    page_num: this.page_num,
                    page_size: this.page_size,
                    post_name: this.condition.post_name,
                }).then((response) => {
                    var code = response.data.code;
                    var data = response.data.data;

                    if (code === '200') {

                        this.tableData = data.list;
                        this.total = data.total;

                    } else {
                        this.$message.warning("请求失败！请稍后重试");
                    }
                }).catch((error) => {
                    console.log(error)
                    this.$message.error("服务器未响应！请稍后重试");
                })
            },
            //新增页面
            AddFrom() {
                this.trash();
                this.dialogVisible = true;
            },
            //添加操作
            Add() {
                this.$refs["from"].validate((valid) => {
                    if (valid) {

                        const url = this.$globals.http + "post/add";
                        axios.post(url, {
                            post_name: this.from.post_name,
                        }).then((response) => {
                            var code = response.data.code;
                            var data = response.data.data;

                            if (code === '200') {

                                this.$message.success(data);
                                this.Return();

                            } else {
                                this.$message.warning("请求失败！请稍后重试");
                            }
                        }).catch((error) => {
                            console.log(error)
                            this.$message.error("服务器未响应！请稍后重试");
                        })

                    }
                });
            },
            //编辑页面
            UpdateFrom(e) {
                this.trash();
                this.from.id = e.id;
                this.from.post_name = e.post_name;
                this.dialogVisible = true;
            },
            //编辑操作
            Update() {
                this.$refs["from"].validate((valid) => {
                    if (valid) {

                        const url = this.$globals.http + "post/modify";
                        axios.post(url, {
                            id: this.from.id,
                            post_name: this.from.post_name,
                        }).then((response) => {
                            var code = response.data.code;
                            var data = response.data.data;

                            if (code === '200') {

                                this.$message.success(data);
                                this.Return();

                            } else {
                                this.$message.warning("请求失败！请稍后重试");
                            }
                        }).catch((error) => {
                            console.log(error)
                            this.$message.error("服务器未响应！请稍后重试");
                        })

                    }
                });
            },
            //删除
            Del(e) {
                var ids;
                if (e === null || e === "" || e === undefined) {
                    if (this.ids === null || this.ids.length <= 0) {
                        this.$message.warning("请先选择操作数据！");
                        return false;
                    }
                    ids = this.ids;
                } else {
                    ids = [e];
                }

                const url = this.$globals.http + "post/del";
                axios.post(url, {
                    ids: ids,
                }).then((response) => {
                    var code = response.data.code;
                    var data = response.data.data;

                    if (code === '200') {

                        this.$message.success(data);
                        this.Find();

                    } else {
                        this.$message.warning("请求失败！请稍后重试");
                    }
                }).catch((error) => {
                    console.log(error)
                    this.$message.error("服务器未响应！请稍后重试");
                })
            },
            //分页查询
			handleCurrentChange(e){
				this.page_num = e;
				this.Find();
			},
            //清除数据
            trash() {
                this.from.post_name = "";
                this.from.id = "";
            }
        },
        async created() {
            this.Find();
        }
    }
</script>

<style scoped="scoped">
    >>>.el-button:hover {
        background-color: #FFFFFF;
    }

    >>>.el-button:focus {
        background-color: #FFFFFF;
    }

    >>>.el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #006E4B;
    }

    >>>.el-input__inner:focus {
        border-color: #006E4B;
    }

    >>>.el-select .el-input.is-focus .el-input__inner {
        border-color: #006E4B;
    }

    >>>.el-checkbox__input.is-checked .el-checkbox__inner,
    >>>.el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: #006E4B;
        border-color: #006E4B;
    }

    >>>.el-checkbox__inner:hover {
        border-color: #006E4B;
    }
</style>



// WEBPACK FOOTER //
// Post.vue?432bcd32